var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDarkCarMiles(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 77 77",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        stroke-width: 2px;\n      }\n\n      .cls-1, .cls-2, .cls-3, .cls-4, .cls-5, .cls-6 {\n        stroke-linecap: round;\n        stroke-linejoin: round;\n      }\n\n      .cls-1, .cls-3 {\n        fill: #0ffdc2;\n      }\n\n      .cls-1, .cls-5 {\n        stroke: #02222b;\n      }\n\n      .cls-2 {\n        fill: #02222b;\n      }\n\n      .cls-2, .cls-3, .cls-4, .cls-5, .cls-6 {\n        stroke-width: 3px;\n      }\n\n      .cls-2, .cls-3, .cls-4, .cls-6 {\n        stroke: #fff;\n      }\n\n      .cls-4 {\n        opacity: .8;\n      }\n\n      .cls-4, .cls-5, .cls-6 {\n        fill: none;\n      }\n\n      .cls-6 {\n        opacity: .5;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer_1"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M69.7,66.1h.2c.7,0,4.7-.4,4.7-1.8v-7.1c0-.7-.2-1.3-.6-1.8-.9-1.2-2.7-3.1-6.4-4.1-4.3-1.2-8.5-1.5-10.1-1.6s-.9-.2-1.4-.4l-11.4-6.4s-2.6-1.4-7-1.4h-10.9c-.7,0-3.5.4-5.5,1.3s-9.9,5.1-11.1,5.7-.2,0-.3,0c-.6.2-3.5,1.3-4.2,1.2s-.3,0-.5,0c-1.8,0-2.1,1.1-2,2.9s0,1.4.5,2,.4,1.2.3,1.8c0,1.1-.4,2.8-.8,3.4-.6,1.1-.8,1.6-.8,3.5s1.6,2.7,3.1,2.7h64.2Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-2",
    cx: 61.2,
    cy: 66.1,
    r: 6.4
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-2",
    cx: 19.4,
    cy: 66.1,
    r: 6.4
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-5",
    x1: 5.1,
    y1: 56,
    x2: 9.6,
    y2: 56
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M16.2,50.2l1.6,1.6c.5.5,1.2.8,2,.8h27.1c.5,0,.9,0,1.3-.3l1.6-.9"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M71.7,46h1.8c.6,0,1.1-.5,1.1-1.2v-6c0-.7-.2-1.4-.6-2-.9-1.2-2.7-3.3-6.4-4.3-4.3-1.2-8.5-1.6-10.1-1.7s-.9-.2-1.4-.4l-11.4-6.8s-2.6-1.4-7-1.4h-10.9c-.7,0-3.5.4-5.5,1.3s-9.9,5.4-11.1,6-.2.1-.3.2c-.6.2-3.5,1.4-4.2,1.3s-.3,0-.5,0c-1.1,0-1.9.8-2,2,0,1.2,0,2.2.4,3.3s.5,5.6.2,6.2"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M71.7,27.7h1.8c.6,0,1.1-.5,1.1-1.2v-6c0-.7-.2-1.4-.6-2-.9-1.2-2.7-3.3-6.4-4.3-4.3-1.2-8.5-1.6-10.1-1.7s-.9-.2-1.4-.4l-11.4-6.8s-2.6-1.4-7-1.4h-10.9c-.7,0-3.5.4-5.5,1.3s-9.9,5.4-11.1,6-.2.1-.3.2c-.6.2-3.5,1.4-4.2,1.3s-.3,0-.5,0c-1.1,0-1.9.8-2,2s0,2.2.4,3.3.5,5.6.2,6.2"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDarkCarMiles);
export default __webpack_public_path__ + "static/media/dark-carMiles.18e6ececca97759679abbb063804d34b.svg";
export { ForwardRef as ReactComponent };